import React from 'react';
import { motion } from 'framer-motion';
import { DAILY_BASE_XP, POST_GATE_XP } from '../data/habits';
interface XPIndicatorProps {
  xp: number;
  tone?: 'dark' | 'light';
  /** Marks the 50 XP point where the full Post unlocks. */
  showGate?: boolean;
}
export function XPIndicator({
  xp,
  tone = 'light',
  showGate = true
}: XPIndicatorProps) {
  const pct = Math.max(0, Math.min(100, xp / DAILY_BASE_XP * 100));
  const track = tone === 'dark' ? 'bg-white/15' : 'bg-sand-deep';
  return <div className="w-full" data-id="element-1256" data-mp="21ha7ffey0xai">
      <div className={`relative h-[7px] w-full overflow-hidden rounded-pill ${track}`} data-id="element-1257" data-mp="21ilafd0ke10k">
        <motion.div className="h-full rounded-pill bg-gold" initial={false} animate={{
        width: `${pct}%`
      }} transition={{
        duration: 0.28,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-1258" data-mp="26fv5b86q34vs" />
      </div>
      {showGate && <div className="relative mt-[3px] h-[12px]" data-id="element-1259" data-mp="1dqegekiba64b">
          <span className={`absolute -translate-x-1/2 text-[9px] font-medium ${xp >= POST_GATE_XP ? 'text-gold' : tone === 'dark' ? 'text-ondark' : 'text-muted'}`} style={{
        left: `${POST_GATE_XP}%`
      }} data-id="element-1260" data-mp="1iq0wd1piy0gt">
            {POST_GATE_XP}
          </span>
        </div>}
    </div>;
}